import { show } from "~/api/contractSpendingChart";
import * as types from "../mutation-types";
import store from "../../store";

/**
 * Initial state
 */
export const state = {
  series: [],
  seriesSpendingBalance: [],
  seriesSpendingBarInfo: [],
  isLoading: false
};

/**
 * Mutations
 */
export const mutations = {
  [types.SET_IS_LOADING_SERIES_CONTRACT_SPENDING_CHART](state, status) {
    state.isLoading = status;
  },
  [types.CLEAR_SERIES_CONTRACT_SPENDING_CHART](state) {
    state.seriesSpendingBalance = [];
  },
  [types.SET_SERIES_CONTRACT_SPENDING_BAR_INFO_CHART](state, data) {
    let result = [];

    Object.entries(data).forEach(([key, value]) => {
      if (key === "0") {
        result.push({
          color: "blue",
          name: "Баланс",
          type: "spline",
          data: value
        });
      } else {
        switch (key) {
          case "10":
            key = "Витрати за сховище";
            break;
          case "1":
            key = "Загальні витрати";
            break;
          case "20":
            key = "Витрати БД";
            break;
        }

        result.push({
          type: "column",
          yAxis: 1,
          name: key,
          data: value
        });
      }
    });

    state.seriesSpendingBarInfo = result;
  },
  [types.SET_SERIES_CONTRACT_SPENDING_CHART](state, data) {
    let result = [];

    Object.entries(data).forEach(([key, value]) => {
      let seriesName;
      switch (key) {
        case "10":
          seriesName = "Сховища";
          break;
        case "1":
          seriesName = "Загальні витрати";
          break;
        case "20":
          seriesName = "База даних";
          break;
        case "30":
          seriesName = "Запити до сайтів";
          break;
        case "31":
          seriesName = "Навантаження CPU  сайту";
          break;
        case "32":
          seriesName = "Використання  Memory сайту";
          break;
        case "40":
          seriesName = "Сертифікати";
          break;
        case "50":
          seriesName = "Планувальники";
          break;
        case "60":
          seriesName = "Домени";
          break;
        default:
          seriesName = key;
      }

      result.push({
        turboThreshold: 0,
        typeId: Number(key),
        name: seriesName,
        data: value
      });
    });

    state.seriesSpendingBalance = result;
  }
};

/**
 * Actions
 */
export const actions = {
  fetchSeriesChart({ commit }, data) {
    let activeContractId =
      data.contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      commit(types.SET_IS_LOADING_SERIES_CONTRACT_SPENDING_CHART, true);

      return show(activeContractId, data.typeId, data.stepTypeId).then((response) => {
        if (response && response.data && response.data.data) {
          commit(types.SET_SERIES_CONTRACT_SPENDING_CHART, response.data.data);
        }
        commit(types.SET_IS_LOADING_SERIES_CONTRACT_SPENDING_CHART, false);
        return response;
      }).catch((error) => {
        commit(types.SET_IS_LOADING_SERIES_CONTRACT_SPENDING_CHART, false);
        throw error;
      });
    } else {
      commit(types.SET_IS_LOADING_SERIES_CONTRACT_SPENDING_CHART, false);
      return Promise.resolve();
    }
  }
};

/**
 * Getters
 */
export const getters = {
  seriesSpendingBalance: (state) => state.seriesSpendingBalance,
  seriesSpendingBarInfo: (state) => state.seriesSpendingBarInfo,
  isLoading: (state) => state.isLoading
};
